import * as marietta from '../../..';
import { CONTROL_ACTIONMODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';
import { Stage } from '../../model';

export default class SiteCornerDragger {
    moveFunc: Function;

    moveEndFunc: Function;

    index: number;

    x: number;

    y: number;

    transformMatrix: string;

    public spt: SVGSprite;

    private moveMouseEvent: MouseEvent;

    /**
     * コンストラクタ
     * */
    constructor(targetSprite: SVGSprite, _index: number) {
      this.index = _index;
      // 描画
      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      viewObj.setAttribute('width', '10');
      viewObj.setAttribute('height', '10');
      viewObj.setAttribute('x', '-5');
      viewObj.setAttribute('y', '-5');
      viewObj.setAttribute('stroke', '#3598DC');
      viewObj.setAttribute('stroke-width', '1');
      viewObj.setAttribute('fill', '#3598DC');
      viewObj.setAttribute('id', `itemController_corner_${_index}`);
      this.spt = new SVGSprite(viewObj);
      targetSprite.addChild(this.spt);

      // アクション
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        viewObj.addEventListener('mousedown', this.onMouseDownMe);
      }
      ua = null;
    }

    /**
 * マウスダウンされた
 * @param MouseEvent
 */
    onMouseDownMe = (e: MouseEvent&TouchEvent) => {
      // 選択モードのときは、バブリングさせない
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
        e.stopPropagation();
      }

      // ドラッグの開始
      e.preventDefault();
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
        document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
      } else {
        document.addEventListener('mousemove', this.onMouseMoveMe);
        document.addEventListener('mouseup', this.onMouseUpMe);
      }

      // comment k.kubonaka
      // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
      // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
      const scope: SiteCornerDragger = this;

      this.spt.onEnterFrame = (): void => {
        if (scope.moveMouseEvent != null) {
          scope.moveFunc(scope.moveMouseEvent, scope);
        }
      };
      ua = null;
    }

    /**
     * マウスが移動した
     */
    onMouseMoveMe = (e: MouseEvent&TouchEvent) => {
      const self:SiteCornerDragger = this; // 現在の場所

      // pad スマホ用タッチ座標修正
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (e.touches.length >= 2) {
          // self.deleteMe();
          self.onMouseUpMe(e);
          return;
        }

        e.stopPropagation();
        Stage.refreshStageMouse(<any>e);
      }

      self.moveMouseEvent = e;
    }

    /**
     * マウスがUPされた
     */
    onMouseUpMe = (e: MouseEvent&TouchEvent) => {
      e.preventDefault();
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;

      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchmove', this.onMouseMoveMe);
        document.removeEventListener('touchend', this.onMouseUpMe);
      } else {
        document.removeEventListener('mousemove', this.onMouseMoveMe);
        document.removeEventListener('mouseup', this.onMouseUpMe);
      }
      ua = null;

      // 終了の処理
      this.moveEndFunc(e, this);

      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.x = x;
      this.y = y;
      this.updateTranslate();
    }

    /**
    * 移動X
    */
    moveX(x: number) {
      this.x = x;
      this.updateTranslate();
    }

    /**
    * 移動Y
    */
    moveY(y: number) {
      this.y = y;
      this.updateTranslate();
    }

    /**
     * Translateのアップデート
     */
    updateTranslate() {
      // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      let sc: number = 1 / root.scaleX;

      // iPad・スマホは掴みやすくする
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        sc *= 2; // 2倍の大きさにする
      }

      this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x},${this.y})`;
      this.spt.element.setAttribute('transform', this.transformMatrix);
    }

    /**
 * 表示ON
 */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示OFF
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }
}
